const actions = {
  SEARCH_USER_BEGIN: 'SEARCH_USER_BEGIN',
  SEARCH_USER_SUCCESS: 'SEARCH_USER_SUCCESS',
  SEARCH_USER_ERR: 'SEARCH_USER_ERR',

  searchUserBegin: () => {
    return {
      type: actions.SEARCH_USER_BEGIN,
    };
  },

  searchUserSuccess: (data) => {
    return {
      type: actions.SEARCH_USER_SUCCESS,
      data,
    };
  },

  searchUserErr: (err) => {
    return {
      type: actions.SEARCH_USER_ERR,
      err,
    };
  },
};

export default actions;
